export default {"src":"/_next/static/media/accordion-down.7dd019bc.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};